import {useDispatch, useSelector} from 'react-redux';

import transformUserData from '../../utils/transformUserData';
import {
  addReview,
  resetReviews as resetReviewsAction,
  selectReviewsWidget,
  setReviews,
} from './reviewsWidgetSlice';

const getPreparedReviews = (reviews) => {
  return reviews.map((review) => ({
    id: review.id,
    comment: review.comment,
    rating: review.score,
    user: transformUserData(review.creator),
  }));
};

const useReviewsWidget = () => {
  const dispatch = useDispatch();

  const {reviews} = useSelector(selectReviewsWidget);

  const addCourseReview = (newReviews) => {
    const allReviews = {
      data: getPreparedReviews([newReviews]),
      totalAmount: reviews.total_amount,
    };

    dispatch(addReview(allReviews));
  };

  const setCourseReviews = (newReviews) => {
    const allReviews = {
      data: getPreparedReviews(newReviews.data),
      totalAmount: newReviews.total_amount,
    };

    dispatch(setReviews(allReviews));
  };

  const resetReviews = () => {
    dispatch(resetReviewsAction());
  };

  return {
    reviews,
    setCourseReviews,
    addCourseReview,
    resetReviews,
  };
};

export default useReviewsWidget;
